import { render, staticRenderFns } from "./LeaderBoard.vue?vue&type=template&id=d8a8ae76&scoped=true&"
import script from "./LeaderBoard.vue?vue&type=script&lang=js&"
export * from "./LeaderBoard.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a8ae76",
  null
  
)

export default component.exports